import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../../models/book-widget-fields-master-config.interfaces';
import { flexAirportRulesOnInitEval } from './flex-airport-rules-on-init.adapter';
import { flexDatesRulesOnInitEval } from './flex-dates-rules-on-init.adapter';
import { shopMilesRulesOnInitEval } from './shop-miles-rules-on-init.adapter';
import { tripTypeRulesOnInitEval } from './trip-type-rules-on-init.adapter';

export const bookWidgetFieldsRulesOnInitEval = (
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig
): BookWidgetFields => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  updatedBookWidgetFields = shopMilesRulesOnInitEval(updatedBookWidgetFields);

  updatedBookWidgetFields = flexDatesRulesOnInitEval(
    updatedBookWidgetFields,
    bookWidgetFieldsMasterConfig
  );

  updatedBookWidgetFields = flexAirportRulesOnInitEval(updatedBookWidgetFields);

  updatedBookWidgetFields = tripTypeRulesOnInitEval(updatedBookWidgetFields);

  return updatedBookWidgetFields;
};
